// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"510":"fd45fe42141874e42e7a","998":"ce55d60ad250febdcffa"}[chunkId] + ".js";
};